import {Component, Input, OnInit} from "@angular/core";
import {SessionService} from "../../services/session.service";

@Component({
  selector:'onlineHelp',
  templateUrl: './OnlineHelpComponent.html',
  // styleUrls: [
  //   '../home.component.css'
  // ],
  providers: [
    // { provide: TreeviewI18n, useClass: MyTreeViewForUnitI18n }
  ]
})


export class OnlineHelpComponent implements OnInit {
  loading = false;

  @Input() urlToHelpFr = "";
  @Input() urlToHelpOther = "";
  @Input() session: SessionService;
  @Input() displayPopup = true;
  @Input() label = "";

  @Input() disableTooltip = false;

  ngOnInit(): void {

  }

  get hasLabel():boolean{
    if (this.label && this.label.length>0){
      return true;
    }
    return false;
  }

}
